import { LoadingOrb } from "./LoadingOrb"

export function CloneOverlay({ visible }) {
  return (
    <div className="clone-overlay" data-clone-overlay hidden={!visible} role="status" aria-live="polite">
      <div className="clone-overlay-card glass">
        <LoadingOrb state="working" />
        <div className="clone-overlay-title">Syncing repository</div>
      </div>
    </div>
  )
}
